module.exports = __webpack_public_path__ + "static/media/hero-img3.1a095686.jpg";